import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let _vm = new Vue()

export default {
    namespaced: true,
    state: {
        allCoupon: null
    },
    mutations: {
        setAllCoupon(state, data){
            state.allCoupon = data
        }
    },
    actions: {
        async getAllCoupon({ commit }){
            let res = await _vm.fetch('/boss/userCoupon/v2/getUserCoupon', {}, 'get')
            res && res.data && commit('setAllCoupon', res.data)
        },
    },
    getters: {
        okCoupons: state => state.allCoupon ? state.allCoupon.validCouponList : [],
        usedCoupons: state => state.allCoupon ? state.allCoupon.usedCouponList : [],
        disabledCoupons: state => state.allCoupon ? state.allCoupon.inValidCouponList : []
    }
}
